import { c as _c } from "react/compiler-runtime";
import { LocalizeProvider } from "@faro-lotv/foreign-observers";
import { runtimeConfig } from "@src/runtime-config";
import { useAppSelector } from "@store/store-helper";
import { devFeaturesStateSelector } from "@store/dev-features/dev-features-selector";
import { isNumberedDevEnvironment } from "@utils/env-utils";
import { isLocalhost } from "@faro-lotv/foundation";
import { LOCALIZE_BLOCKED_CLASSES, shouldEnableSaveNewPhrases } from "@utils/localize-utils";

/** The localization loader making it possible to implement language translation */
export function LocalizeLoader(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const {
    isTranslationOverrideAllowed
  } = useAppSelector(devFeaturesStateSelector);
  let t1;
  if ($[0] !== isTranslationOverrideAllowed) {
    const isNumberDevelopmentEnvironment = isNumberedDevEnvironment();
    t1 = shouldEnableSaveNewPhrases({
      isNumberedDevEnvironment: isNumberDevelopmentEnvironment,
      isLocalhost: isLocalhost(),
      isTranslationOverrideAllowed
    });
    $[0] = isTranslationOverrideAllowed;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSaveNewPhrasesEnabled = t1;
  let t2;
  if ($[2] !== isSaveNewPhrasesEnabled) {
    t2 = {
      saveNewPhrases: isSaveNewPhrasesEnabled,
      blockedClasses: LOCALIZE_BLOCKED_CLASSES
    };
    $[2] = isSaveNewPhrasesEnabled;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <LocalizeProvider projectKey={runtimeConfig.features.localizeKey} initOptions={t2}>{children}</LocalizeProvider>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}